<app-confirm-dialog
  [isOpen]="pendingDeleteFile() !== null"
  [message]="'Are you sure you want to remove \'' + (pendingDeleteFile()?.title ?? '') + '\'?'"
  confirmLabel="Remove"
  cancelLabel="Cancel"
  (confirmed)="onConfirmDelete()"
  (cancelled)="onCancelDelete()"
></app-confirm-dialog>

<app-file-step
  [title]="step().title"
  [description]="step().description"
  [state]="state()"
  [existingFiles]="existingFiles()"
  [newFiles]="newFiles()"
  [editable]="editable()"
  [nextEnabled]="nextEnabled()"
  [fileTypeWhiteList]="fileTypeWhiteList"
  (previousClicked)="previous()"
  (saveClicked)="save()"
  (toggleRemoveExistingFile)="toggleRemoveExistingFile($event)"
  (removeNewFile)="removeNewFile($event)"
  (addNewFiles)="addNewFiles($event)"
  (downloadFile)="onDownloadFile($event)"
></app-file-step>
